import { JetView } from 'webix-jet';
import {
    profile, // User profile configuration
    devConfig, // Development configuration settings
    countries, // List of countries
    paymentSystem, // Payment system configurations
    cashDesks, // Cash desk configurations
    agentList, // List of agents
} from 'config/config';

/**
 * Class representing the filter requests agent view.
 * @extends JetView
 */
export default class FilterRequestsAgentView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Current screen size

        const left = {
            // Left section of the form
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Input for ID
                            name: 'Id',
                            type: 'number',
                            label: _("<span class='icon-id'></span> Id"),
                            labelPosition: 'top',
                            placeholder: _('Id'),
                        },
                        {
                            view: 'text', // Input for Agent name
                            name: 'Agent',
                            type: 'text',
                            label: "<span class='icon-user-secret'></span>" + _('Agente'),
                            labelPosition: 'top',
                            placeholder: _('Agente'),
                        },
                        {
                            view: 'text', // Datepicker input
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            readonly: true,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha Creación'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                        },
                        {
                            view: 'richselect', // Dropdown for State selection
                            name: 'State',
                            localId: 'bonusStates:combo',
                            label: "<span class='icon-state'></span>" + _('Estado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                // Options for the state dropdown
                                { id: '', value: _('Todos') },
                                { id: 'A', value: _('Aprobados') },
                                { id: 'R', value: _('Rechazados') },
                                { id: 'P', value: _('Pendientes') },
                            ],
                        },
                    ],
                },
            ],
        };

        const upper_section = {
            // Upper section containing the left form
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 200 : 0, // Responsive height
            rows: [
                {
                    margin: 10,
                    cols: [left],
                },
            ],
        };

        const buttons = {
            // Button section for form actions
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 }, // Placeholder for layout
                        {
                            view: 'button', // Clear button
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                $$('myForm').setValues(
                                    // Reset form values
                                    $$('myForm').getCleanValues(),
                                );
                                $$('Datepicker').setValue(''); // Clear datepicker
                            },
                        },
                        {
                            view: 'button', // Consult button
                            value: _('Consultar'),
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                this.app.callEvent('requestsAgent:filter', [filterdata]); // Trigger filter event
                            },
                        },
                    ],
                },
            ],
        };

        return {
            // Return the complete form configuration
            view: 'form',
            id: 'myForm',
            rows: [upper_section, buttons],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for form
            },
        };
    }

    /**
     * Initializes the view after the configuration is set.
     * @param {Object} form - The form instance.
     */
    init(form) {
        webix.ready(function () {
            if (screen.width < 500) {
                // Hide element on small screens
                $$('grav').hide();
            }
        });
    }
}

// FILE DOCUMENTED
